import React from 'react';
import {
  Box,
  Button,
  Icons,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import {
  getBackButtonRoute,
  goToMySpaceNav,
  goToParticipantsWithBackButton,
} from '@core/constants/backButtonNavigation';
import pushRoute from '@app/utils/routing';
import commonRoomIcon from '@static/common_room.svg';
import { createStyles } from './CommonRoomResponsive.styles';

interface CommonRoomSidebarProps {
  participantTotal: number;
  spaceId?: string;
}

const CommonRoomSidebar = ({
  participantTotal,
  spaceId,
}: CommonRoomSidebarProps) => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const backRoute =
    getBackButtonRoute() || (spaceId && goToMySpaceNav(spaceId));

  const handleBack = () => {
    if (backRoute) pushRoute(backRoute);
  };

  const handleParticipants = () => {
    if (spaceId) pushRoute(goToParticipantsWithBackButton(spaceId));
  };

  return (
    <Box component="aside" sx={styles.sidebar} aria-label="Common Room">
      <Button
        kind="secondary"
        onClick={handleBack}
        disabled={!backRoute}
        startIcon={<Icons.WestOutlined aria-hidden="true" />}
        aria-label="Back to space navigation"
        sx={styles.backButton}
      >
        Back
      </Button>

      <Box sx={styles.titleRow}>
        <Box sx={styles.titleIcon} aria-hidden="true">
          <img
            src={commonRoomIcon}
            alt=""
            width="40"
            height="40"
            data-testid="common-room-icon"
          />
        </Box>
        <Typography component="h1" variant="h5" sx={styles.title}>
          Common room
        </Typography>
      </Box>

      <Button
        kind="secondary"
        onClick={handleParticipants}
        disabled={!spaceId}
        startIcon={<Icons.PeopleOutlined aria-hidden="true" />}
        aria-label={`View participants, ${participantTotal} total`}
        sx={styles.participantsButton}
      >
        Participants ({participantTotal})
      </Button>
    </Box>
  );
};

export default CommonRoomSidebar;
